'use client'
import { useState } from 'react'
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Card } from '../ui/card'
import { FAQ_DATA } from '@/helper/DATA'
import FaqAnswer from '@/components/common/FaqAnswer'

// Number of FAQs shown before the "View more" toggle is used.
const VISIBLE_FAQ_COUNT = 5

const FAQExpandToggle = () => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <>
      <Accordion type="single" collapsible className="border-0 grid gap-3 mb-6">
        {FAQ_DATA.map((item: any, index: number) => (
          <AccordionItem
            key={item.question}
            value={item.question}
            // Every FAQ is rendered so all questions and answers land in the
            // server HTML. Items past the fold are hidden with CSS, never
            // sliced out - slicing kept them out of view-source entirely.
            className={`border border-gray-300 rounded-lg overflow-hidden data-[state=open]:border-primary-100 transition-all duration-300 ${
              !isExpanded && index >= VISIBLE_FAQ_COUNT ? 'hidden' : ''
            }`}
          >
            <Card className="py-4 px-5 sm:py-5 sm:px-6 border-0 shadow-none bg-white">
              <AccordionTrigger className="text-body-md sm:text-label-lg font-medium p-0 hover:no-underline text-left text-gray-900">
                {item.question}
              </AccordionTrigger>
              <AccordionContent
                forceMount
                className="text-body-sm sm:text-body-md text-gray-700 leading-relaxed pt-3 pb-0"
              >
                <FaqAnswer
                  answer={item.answer}
                  className="space-y-3 [&_ol]:list-decimal [&_ol]:pl-5 [&_ol]:space-y-2 [&_strong]:font-semibold"
                />
              </AccordionContent>
            </Card>
          </AccordionItem>
        ))}
      </Accordion>
      <button
        type="button"
        aria-expanded={isExpanded}
        className="text-label-md font-semibold text-primary-600 hover:text-primary-700 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? 'View less' : 'View more'}
      </button>
    </>
  )
}

export default FAQExpandToggle
